import { Component, Input, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef, NgZone, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/shared/material.module';
import * as QRCode from 'qrcode';
import { DigitalCard, social_links } from 'src/app/services/cards.service';
import { environment } from 'src/environments/environment';
import { Router, RouterModule } from '@angular/router';
import { BreadcrumbComponent } from 'src/app/components/shared/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule, MaterialModule, RouterModule, BreadcrumbComponent],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements AfterViewInit, OnChanges {
  @Input() card: DigitalCard | null = null;
 @ViewChild('qrCanvas', { static: false }) qrCanvas!: ElementRef<HTMLCanvasElement>;

  environment = environment;
  qrLoading = false;

  constructor(private router: Router, private cd: ChangeDetectorRef, private ngZone: NgZone) {}

 ngAfterViewInit() {
  // Also try generating in case card input was already available
  if (this.card) {
    setTimeout(() => this.generateQr(), 50);
  }
}

  ngOnChanges(changes: SimpleChanges) {
  if (changes['card'] && this.card) {
    // ensure canvas exists
    setTimeout(() => this.generateQr(), 50);
  }
}


private generateQr() {
  if (!this.card?.handler || !this.qrCanvas) return;

  this.qrLoading = true;
  const canvasEl = this.qrCanvas.nativeElement;

  setTimeout(() => {
    QRCode.toCanvas(canvasEl, `${environment.appUrl}/${this.card!.handler}`, { width: 180 })
      .then(() => {
        this.qrLoading = false;
      })
      .catch(err => {
        console.error('QR generation error', err);
        this.qrLoading = false;
      });
  }, 50);
}

  goToEditPage() {
    if (!this.card?.id) return;
    this.router.navigate([`/card/${this.card.id}/edit`]);
  }

  downloadCard() {
  if (!this.card?.id) return;
  this.router.navigate([`/card/${this.card.id}/download`]);
}

  copyHandlerLink() {
    if (!this.card?.handler) return;
    const link = `${environment.appUrl}/${this.card.handler}`;
    navigator.clipboard.writeText(link).then(() => alert('Handler link copied!'));
  }

  async shareHandlerLink() {
    if (!this.card?.handler) return;
    const link = `${environment.appUrl}/${this.card.handler}`;
    if (navigator.share) {
      try { await navigator.share({ title: this.card.business_info?.businessName || 'Digital Card', text: 'Check out this card', url: link }); }
      catch (err) { console.error(err); }
    } else {
      alert(`Share this link: ${link}`);
    }
  }

  formatPhone(phone?: string) {
    return phone?.startsWith('+') ? phone : `+91 ${phone}`;
  }

  get socialLinkArray(): social_links[] {
    return this.card?.social_links?.filter(s => s.platform && s.url) || [];
  }

  get quickLinkArray(): { title: string; url: string }[] {
    if (!this.card?.quick_links || this.card.quick_links.length === 0) return [];
    return this.card.quick_links.filter(link => link.title && link.url);
  }


}